export default __webpack_public_path__ + "static/rewards-cube-1-9df54ebe291f621362fdcb4d82262168.svg";